import { useEffect, useState } from "react";
import { DeviceType, DeviceTypeEnum } from "./props";

export const useDeviceType = (): DeviceType => {
  const [isMobile, setIsMobile] = useState(false);
  const [deviceType, setDeviceType] = useState<DeviceTypeEnum>(
    DeviceTypeEnum.DESKTOP
  );

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;

      const isWindowMobile = width < 768;
      setIsMobile(isWindowMobile);

      if (isWindowMobile) {
        setDeviceType(DeviceTypeEnum.MOBILE);
      } else if (width >= 768 && width < 1024) {
        setDeviceType(DeviceTypeEnum.TABLET);
      } else {
        setDeviceType(DeviceTypeEnum.DESKTOP);
      }
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return { isMobile, deviceType };
};
